import React, { useRef } from "react";
import Slider from "react-slick";
import { BannerSliderData } from "../../Utils/constants";
import { isEmpty } from "lodash";
import { useContext } from "react";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useNavigate } from "react-router-dom";
import GameSliderHeader from "../../components/GameSliderHeader";
import { apiGet, apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { liveGameData } from "../../constraints/constants";
import ImageWithPlaceholder from "../../components/ImageWithPlaceholder";

const LiveCashino = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: false,
    arrows: false,
    slidesToScroll: 3,
    centerPadding: "10px",
    slidesToShow: 3,
    // rows: 2,
    slidesPerRow: 1,
  };
  const lang = useContextSelector(AuthContext, (ctx) => ctx.lang);
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const launchEGTCasino = useContextSelector(
    AuthContext,
    (ctx) => ctx.launchEGTCasino,
  );
  const launchCasino = useContextSelector(
    AuthContext,
    (ctx) => ctx.launchCasino,
  );
  const withoutLogin = useContextSelector(
    AuthContext,
    (ctx) => ctx.withoutLogin,
  );
  const navigate = useNavigate();
  const sliderRef = useRef(null);

  return (
    <>
      <GameSliderHeader title="LIVE CASINO" to="/casino?header=live&subCasino=all" sliderRef={sliderRef} />
      <div className="hotgame-slider border-0 p-0">
        <div>
          <Slider ref={sliderRef} {...settings}>
            {liveGameData?.map((item) => {
              return (
                <div
                  onClick={() => {
                    if (!isEmpty(item?.link)) {
                      navigate(`/casino?header=live&subCasino=${item?.link}`);
                    } else {
                      if (!isEmpty(user)) {
                        launchCasino({
                          platForm: item?.platForm,
                          gameType: item?.gameType,
                          casinoType: item?.casinoType,
                          isLobbyTrue: true,
                        });
                      } else {
                        navigate("/login");
                      }
                    }
                  }}
                  className="slider-items"
                >
                  <figure className="mb-0 shine">
                    <ImageWithPlaceholder src={item?.img} alt={item?.img} />
                  </figure>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default LiveCashino;
